import { Td, Tr } from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ChevronDown from 'components/Icons/ChevronDown';
import ChevronRight from 'components/Icons/ChevronRight';
import { getDashboardBlocks, handleSelectedRow } from 'redux/DashboardSliceV2';
import { getDataTypeBasedValuewithNewValue } from 'utils/FormatValues';

interface Properties {
  row: any;
  expandkey: string;
  isDashboardLayout?: boolean;
}
export interface NewTotalValues {
  Time: string;
  value: number | null;
  value2?: number | null;
  diff?: number | null;
  varience?: number | null;

  isShow?: boolean;
  isShowExpandable?: boolean;
  isExpandedColumn?: boolean;
  isActualValue?: boolean;
}

const DashboardTableRow = ({ row, expandkey, isDashboardLayout }: Properties) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const dispatch = useDispatch();
  const modalBlocks = useSelector(getDashboardBlocks);
  const dataType = useMemo(() => {
    try {
      const foundBlock: any = modalBlocks.find((block: any) => {
        return block.block_id === row.indicator.block_id;
      });
      if (foundBlock?.indicators) {
        const indicator = foundBlock?.indicators.find((ind: any) => {
          return row?.indicator?.indicator_id === ind.indicator_id;
        });
        return {
          formatProperties: indicator?.data_format_properties,
          data_type: indicator?.data_format,
        };
      }
    } catch {
      return null;
    }
    return null;
  }, [row, modalBlocks]);
  const onToggleCollapse = () => {
    if (!isDashboardLayout) {
      dispatch(handleSelectedRow(row.indicator));
    }
    setIsCollapsed((previousState) => !previousState);
  };

  const getObjectValue = (object: any) => {
    return Object.values(object);
  };

  const subData: any = row.dim_df
    ? Object.entries(row.dim_df).map((entry: any) => ({
        item_name: getObjectValue(entry[1])[0],
        item_values: entry[1].values || [],
      }))
    : [
        {
          item_name: 'Total',
          item_values: row.total || [],
        },
      ];

  const isConditionalFormatting = (displayValue: any) => {
    switch (row.conditional_formatting?.value) {
      case 'is less than':
        return displayValue < Number(row.conditional_formatting?.formatting?.value);
      case 'is greater than':
        return displayValue > Number(row.conditional_formatting?.formatting?.value);
      case 'equal to':
        return displayValue === Number(row.conditional_formatting?.formatting?.value);
      default:
        return false;
    }
  };

  const getBackgroundStyle = (
    output_format: any,
    key: string,
    isExpandedColumn: boolean,
    isSubRow?: boolean,
    isActualValue?: boolean,
    value?: any,
  ) => {
    const subTotalIndicator = isSubRow ? '#EFFDFE' : '#BCEEF2';
    const regularIndicator = '#EFFDFE';
    const subTotalIndicatorTimeExpansion = isSubRow ? '#DEF2F3' : '#A7E6EB';
    const regularIndicatorTimeExpansion = '#DEF2F3';
    if (output_format) {
      return {
        textAlign: output_format?.textAlign,
        backgroundColor: output_format?.cellColor,
        color: isConditionalFormatting(value)
          ? row.conditional_formatting?.formatting?.color
          : output_format?.textColor,
        textDecoration: output_format?.textDecoration,
        fontStyle: output_format?.textDecoration,
        fontWeight: output_format?.textDecoration === 'bold' ? '700' : '400',
      };
    }

    if (isExpandedColumn) {
      return {
        background: isActualValue
          ? output_format === 'subtotal'
            ? subTotalIndicatorTimeExpansion
            : regularIndicatorTimeExpansion
          : '#E7EBEF',
      };
    }

    if (key === expandkey && isSubRow) {
      return {
        background: isActualValue
          ? output_format === 'subtotal'
            ? regularIndicatorTimeExpansion
            : regularIndicatorTimeExpansion
          : '#D1D9E0',
      };
    }

    if (key === expandkey && !isSubRow) {
      return {
        background: isActualValue
          ? output_format === 'subtotal'
            ? subTotalIndicatorTimeExpansion
            : regularIndicatorTimeExpansion
          : '#D1D9E0',
      };
    }

    const color = isActualValue ? subTotalIndicator : '#F4F7FF';

    return {
      background: output_format === 'subtotal' ? color : isActualValue ? regularIndicator : '#FFF',
    };
  };

  console.log('row=>', row, row.indicator?.indicator_name);
  return (
    <>
      <Tr
        // border={'1px solid red'}
        height={'8'}
        onClick={onToggleCollapse}
        fontWeight={row?.output_format === 'subtotal' ? 'semibold' : 'regular'}
      >
        <Td
          style={{
            ...getBackgroundStyle(row.indicator?.formatting, '-', false, false, true, true),
            cursor: row.dim_df ? 'pointer' : 'default',
            textAlign: 'start',
            paddingLeft: '1rem',
            verticalAlign: 'middle',
            // Freeze the indicator name column so it stays visible when scrolling right.
            position: 'sticky',
            left: 0,
            zIndex: 1,
            background: 'white',
          }}
          fontSize={'2xs'}
          textAlign={'start'}
          data-testid='table-header'
          borderBottom={isCollapsed ? '1px solid #D9D9D9' : ''}
        >
          {row.dim_df ? isCollapsed ? <ChevronRight /> : <ChevronDown /> : <></>}
          {row.indicator?.indicator_name}
        </Td>
        {Object.values(row.total as unknown as NewTotalValues[]).map((item: any, index) => {
          if (item.isShow) {
            if (item.value === null) {
              return (
                <Td
                  key={item.Time + index}
                  style={getBackgroundStyle(
                    row.indicator?.formatting,
                    item.Time,
                    Boolean(item?.isExpandedColumn),
                    false,
                    Boolean(item?.isActualValue),
                  )}
                  fontSize={'2xs'}
                >
                  {dataType?.formatProperties?.null_value}
                </Td>
              );
            }
            return (
              <Td
                key={item.Time + index}
                // paddingRight='1rem'
                style={getBackgroundStyle(
                  row.indicator?.formatting,
                  item.Time,
                  Boolean(item?.isExpandedColumn),
                  false,
                  Boolean(item?.isActualValue),
                  getObjectValue(item)[1],
                )}
                verticalAlign='middle !important'
                textAlign={'end'}
                fontSize={'2xs'}
                borderBottom={isCollapsed ? '1px solid #D9D9D9' : ''}
                // border={'1px solid red'}
              >
                {getDataTypeBasedValuewithNewValue(
                  dataType?.data_type,
                  item[row.indicator?.indicator_name] || 0,
                  dataType?.formatProperties,
                )}
              </Td>
            );
          }
          return <React.Fragment key={item.Time + index}></React.Fragment>;
        })}
      </Tr>

      {!isCollapsed &&
        row.dim_df &&
        subData?.map(
          (subRow: any, index: any) =>
            subRow.item_values &&
            subRow.item_values.length > 0 && (
              <Tr
                height={'9'}
                key={index}
                fontWeight={row?.output_format === 'subtotal' ? 'semibold' : 'regular'}
              >
                <Td
                  pl='1rem'
                  color='grey.900'
                  fontSize={'2xs'}
                  borderBottom={index === subData.length - 1 ? '1px solid #D9D9D9' : ''}
                  style={{
                    position: 'sticky',
                    left: 0,
                    zIndex: 1,
                    background: '#ffffff',
                  }}
                >
                  {subRow.item_name}
                </Td>
                {(subRow.item_values as NewTotalValues[]).map(
                  (itemValue: any, itemValueIndex: number) => {
                    if (itemValue.isShow) {
                      if (itemValue === null) {
                        return (
                          <Td
                            key={itemValue.Time + itemValueIndex}
                            style={getBackgroundStyle(
                              row.output_format,
                              itemValue.Time,
                              itemValue.isExpandedColumn,
                              true,
                              Boolean(itemValue?.isActualValue),
                              getObjectValue(itemValue)[1],
                            )}
                            color='grey.900'
                            fontSize={'2xs'}
                            textAlign={'end'}
                            borderBottom={index === subData.length ? '1px solid #D9D9D9' : ''}
                          >
                            {dataType?.formatProperties.null_value}
                          </Td>
                        );
                      }
                      return (
                        <Td
                          key={itemValue.Time + index}
                          // style={getBackgroundStyle(
                          //   row.output_format,
                          //   itemValue.Time,
                          //   itemValue.isExpandedColumn,
                          //   true,
                          //   Boolean(itemValue?.isActualValue),
                          // )}
                          color='grey.900'
                          fontSize={'2xs'}
                          textAlign={row.indicator?.formatting?.textAlign || 'end'}
                          borderBottom={index === subData.length - 1 ? '1px solid #D9D9D9' : ''}
                        >
                          {getDataTypeBasedValuewithNewValue(
                            dataType?.data_type,
                            itemValue[row.indicator?.indicator_name] || 0,
                            dataType?.formatProperties,
                          )}
                        </Td>
                      );
                    }
                    return <React.Fragment key={itemValue.Time + itemValueIndex}></React.Fragment>;
                  },
                )}
              </Tr>
            ),
        )}
    </>
  );
};

export default DashboardTableRow;
